import { array, object, string } from 'yup';
import 'yup-phone';

const registerSocialSchema = object({
  email: string().email('Invalid email address').required('Required'),
  // When a user logs in with Google, sometimes only one of the first name or last name can be retrieved.
  first_name: string(),
  last_name: string(),
  phone: string()
    .phone(undefined, false, 'The phone number is invalid.')
    .required('Required'),
  invitation_token: string(),
  provider: string().notRequired(),
  uid: string().notRequired(),
  email_verification_code: string(),
  team_name: string(),
  team_emails: array().of(string()),
}).test(
  // When a user logs in with Google, sometimes only one of the first name or last name can be retrieved.
  'name-required',
  'Either first name or last name is required',
  function (value) {
    const { first_name, last_name } = value;
    return !!first_name || !!last_name;
  }
);

export default registerSocialSchema;
